export const DEV_TOUCH_STORE = "DEV_TOUCH_STORE";

export default {
  DEV_TOUCH_STORE
};
